// Styles
import './index.css';

import React from 'react';
import { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// AI Components
import Chat from './components/AI/Chat';
import DataAnalysis from './components/AI/DataAnalysis';
import ImageAnalysis from './components/AI/ImageAnalysis';
import Login from './components/Auth/Login';
// Layout
import Layout from './components/Layout/Layout';
// Context
import { AuthProvider, useAuth } from './contexts/AuthContext.jsx';
import Analytics from './pages/Analytics';
// Pages
import Dashboard from './pages/Dashboard';
import Documents from './pages/Documents';
import KIWorkspace from './pages/KIWorkspace';
import Settings from './pages/Settings';
import Users from './pages/Users';

// React Query Client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 Minuten
    },
  },
});

// Protected Route Component
function ProtectedRoute({ children }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary" />
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  return children;
}

function AppContent() {
  return (
    <Router>
      <div className="App">
        <ProtectedRoute>
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/users" element={<Users />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/ki-workspace" element={<KIWorkspace />} />
              <Route path="/ki-workspace/chat" element={<Chat />} />
              <Route path="/ki-workspace/datenanalyse" element={<DataAnalysis />} />
              <Route path="/ki-workspace/bildanalyse" element={<ImageAnalysis />} />
            </Routes>
          </Layout>
        </ProtectedRoute>

        {/* Toast Notifications */}
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#22c55e',
                secondary: '#fff',
              },
            },
            error: {
              duration: 5000,
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </div>
    </Router>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
